<template lang="pug">
  v-container(fluid)
    v-row(justify="center" align="center" style="min-height: 80vh")
      v-col(cols="12" sm="8" md="6" lg="5")
        v-card.success-card
          // Success Animation
          .text-center.py-8.success-header
            v-avatar(size="96" color="success" class="elevation-4")
              v-icon(size="64" dark) mdi-check
            h1.text-h4.font-weight-bold.mt-4 ¡Reserva Confirmada!
            p.subtitle-1.grey--text.text--darken-1 
              | Te esperamos en {{ restaurant?.name }}
  
          v-card-text.pa-6
            // Reservation Details
            v-list
              v-list-item
                v-list-item-icon
                  v-icon(color="primary") mdi-calendar
                v-list-item-content
                  v-list-item-title Fecha y Hora
                  v-list-item-subtitle {{ formatDateTime(reservation?.date) }}
  
              v-list-item
                v-list-item-icon
                  v-icon(color="primary") mdi-account-group
                v-list-item-content
                  v-list-item-title Personas
                  v-list-item-subtitle {{ reservation?.people }} personas
  
              v-list-item(v-if="reservation?.specialRequests")
                v-list-item-icon
                  v-icon(color="primary") mdi-text-box
                v-list-item-content
                  v-list-item-title Solicitudes Especiales
                  v-list-item-subtitle {{ reservation.specialRequests }}
  
            // Restaurant Info
            v-card(outlined class="mt-6")
              v-card-text
                .d-flex.align-center.mb-4
                  v-icon(color="primary" class="mr-3") mdi-map-marker
                  div
                    .subtitle-1.font-weight-medium Dirección
                    .body-2.grey--text {{ restaurant?.address }}
  
                .d-flex.align-center
                  v-icon(color="primary" class="mr-3") mdi-phone
                  div
                    .subtitle-1.font-weight-medium Teléfono
                    .body-2.grey--text {{ restaurant?.phone }}
  
            // Next Steps
            v-alert.mt-6(
              color="info"
              text
              border="left"
              prominent
            )
              .subtitle-1.font-weight-medium Información Importante
              ul.mt-2
                li Te hemos enviado un email de confirmación
                li Por favor llega 5-10 minutos antes
                li Si necesitas cancelar, hazlo con 24hs de anticipación
  
          v-card-actions.pa-6.pt-0
            v-spacer
            v-btn(
              color="primary"
              :to="`/r/${restaurant?.urlSlug}`"
              large
            )
              v-icon(left) mdi-food
              | Ver Menú
            v-btn(
              outlined
              color="primary"
              :href="`https://www.google.com/maps/search/?api=1&query=${encodeURI(restaurant?.address)}`"
              target="_blank"
              large
            )
              v-icon(left) mdi-map-marker
              | Cómo Llegar
  </template>
  
  <script>
  import { format } from 'date-fns';
  import { es } from 'date-fns/locale';
  
  export default {
    name: 'ReservationSuccess',
  
    data: () => ({
      reservation: null
    }),
  
    computed: {
      restaurant() {
        return this.$store.state.restaurant.current;
      }
    },
  
    methods: {
      formatDateTime(date) {
        if (!date) return '';
        return format(new Date(date), "EEEE d 'de' MMMM 'a las' HH:mm", {
          locale: es
        });
      }
    },
  
    async created() {
      // Get reservation from store or redirect if not found
      this.reservation = this.$store.state.reservations.current;
      if (!this.reservation) {
        this.$router.push('/');
      }
    }
  };
  </script>
  
  <style scoped>
  .success-card {
    border-radius: 16px;
    overflow: hidden;
  }
  
  .success-header {
    background: linear-gradient(45deg, #4CAF50, #81C784);
    color: white;
    position: relative;
  }
  
  .success-header::after {
    content: '';
    position: absolute;
    bottom: -20px;
    left: 0;
    right: 0;
    height: 40px;
    background: white;
    border-radius: 50% 50% 0 0;
  }
  
  .v-list-item {
    padding: 16px 0;
  }
  
  .v-list-item:not(:last-child) {
    border-bottom: 1px solid rgba(0,0,0,0.12);
  }
  
  .v-list-item__icon {
    margin: 12px 16px 12px 0;
  }
  
  .v-avatar {
    transition: transform 0.3s ease;
  }
  
  .v-avatar:hover {
    transform: scale(1.05);
  }
  
  @media (max-width: 600px) {
    .v-card-actions {
      flex-direction: column;
    }
  
    .v-card-actions .v-btn {
      width: 100%;
      margin: 4px 0 !important;
    }
  }
  </style>